module.exports = "/_next/static/images/8dcfe7aa80384df6f8eeda316276874e-card-lg@1x.jpg";